export const theme = {
  primaryDark: "#424242",
  primaryLight: "#EFFFFA",
  primaryHover: "#343078",
  textBlackColor: "#000",
  textWhiteColor: "#fff",
  textBackgroundColor: "gray",
  mobile: "576px",
};
